import PortalTooltipColumn from './PortalTooltipColumn';

export default PortalTooltipColumn;
